// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AdminRole,
  UserType,
} from "./types";


export default __t.row({
  identity: __t.identity().primaryKey(),
  username: __t.option(__t.string()),
  get role() {
    return AdminRole;
  },
  createdAt: __t.timestamp().name("created_at"),
  lastConnectedAt: __t.timestamp().name("last_connected_at"),
  isConnected: __t.bool().name("is_connected"),
  get userType() {
    return UserType.name("user_type");
  },
});
